import { Forward } from "lucide-react";
import { Badge } from "@/components/shadcn/badge";

/** Serialized form of the engine's `Skipped()` marker (noxus/types_v2.py). */
export type SkippedMarker = { skipped: true };

export function isSkippedValue(value: unknown): value is SkippedMarker {
  return (
    typeof value === "object" &&
    value !== null &&
    "skipped" in value &&
    value.skipped === true
  );
}

export function SkippedBadge({ compact = false }: { compact?: boolean }) {
  return (
    <Badge
      variant="outline"
      size={compact ? "sm" : "md"}
      className={compact ? "text-[10px]" : "text-sm gap-2"}
    >
      <Forward className="w-3 h-3" />
      Skipped
    </Badge>
  );
}
